import { linksUpTo } from './_shared';

/**
 * **チェーンの処理の開始**（Issue #589）。`zoom` ＝ ふつうの処理 / `sink` ＝ 無効にされたリンク
 * （発動の無効も効果の無効も）。事実: `chain` / `links`（このリンクまで）/ そのリンクの `player` `code` `uid`
 */
export const VARIANTS = Object.freeze([
  { name: 'zoom', label: '処理' },
  { name: 'sink', label: '無効にされたリンクの処理' },
]);

export default Object.freeze({
  event: 'chain_solving',
  variants: VARIANTS,
  classify({ payload }) {
    const chain = Number(payload?.link?.chain ?? payload?.chain) || 0;
    const links = linksUpTo(payload);
    const me = links.find((l) => l.chain === chain);
    if (!chain || !me) return null;
    return {
      ...payload,
      variant: me.negated || me.disabled ? 'sink' : 'zoom',
      chain,
      links,
      player: me.player,
      code: me.code,
      uid: payload?.link?.uid ?? payload?.uid ?? null,
    };
  },
});
